import { api } from '../configs/axiosConfigs';

export const shareListSort = async({ id, requestBody }) => {
  const requestUrl = `/list-sorts/${id}/share`;
  return await api.post(requestUrl, requestBody);
};
